import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ACCENTS } from "@/data/site";

const PALETTE = [ACCENTS.red, ACCENTS.blue, ACCENTS.yellow, ACCENTS.green];

// Fire a small brand-colored particle burst at a screen coordinate.
export const fireBurst = (x, y, color) => {
  window.dispatchEvent(new CustomEvent("owo-burst", { detail: { x, y, color } }));
};

let uid = 0;

// Listens for burst events and renders short-lived square particles.
export const ConfettiLayer = () => {
  const reduce = useReducedMotion();
  const [bursts, setBursts] = useState([]);

  useEffect(() => {
    if (reduce) return;
    const onBurst = (e) => {
      const { x, y, color } = e.detail;
      const id = uid++;
      const particles = Array.from({ length: 12 }).map((_, i) => {
        const angle = (Math.PI * 2 * i) / 12 + Math.random() * 0.5;
        const dist = 40 + Math.random() * 70;
        return {
          i,
          dx: Math.cos(angle) * dist,
          dy: Math.sin(angle) * dist,
          rot: (Math.random() - 0.5) * 240,
          color: color || PALETTE[i % PALETTE.length],
          size: 5 + Math.random() * 5,
        };
      });
      setBursts((b) => [...b, { id, x, y, particles }]);
      setTimeout(() => setBursts((b) => b.filter((v) => v.id !== id)), 800);
    };
    window.addEventListener("owo-burst", onBurst);
    return () => window.removeEventListener("owo-burst", onBurst);
  }, [reduce]);

  if (reduce) return null;

  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-[9997]">
      <AnimatePresence>
        {bursts.map((burst) => (
          <div key={burst.id} className="absolute" style={{ left: burst.x, top: burst.y }}>
            {burst.particles.map((p) => (
              <motion.span
                key={p.i}
                className="absolute block"
                style={{ width: p.size, height: p.size, backgroundColor: p.color }}
                initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
                animate={{ x: p.dx, y: p.dy, opacity: 0, rotate: p.rot }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              />
            ))}
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
};
